import React, { lazy, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import { Routes } from '../../routes';

import Loader from '../../components/Loader';
const load = (Component) => (props) => (
    <Suspense fallback={<Loader />}>
        <Component {...props} />
    </Suspense>
);

const Header = load(lazy(() => import('../../layouts/executive-director/header')));
const Sidebar = load(lazy(() => import('../../layouts/executive-director/sidebar')));
const Footer = load(lazy(() => import('../../layouts/executive-director/footer')));
const Assets = load(lazy(() => import('../../layouts/executive-director/assets')));
const DirectorNotFound = load(lazy(() => import('./404-director')));
const Dashboard = load(lazy(() => import('./dashboard')));
const ValidasiPengajuan = load(lazy(() => import('../approvers/validasi-pengajuan/validasi-pengajuan')));
const DetailPengajuan = load(lazy(() => import('../approvers/validasi-pengajuan/detail-pengajuan')));
const RiwayatPengajuan = load(lazy(() => import('../riwayat-pengajuan/unit/riwayat-pengajuan-list')));
const RiwayatPengajuanDetailPpbj = load(lazy(() => import('../riwayat-pengajuan/unit/riwayat-pengajuan-detail-ppbj')));
const RiwayatPengajuanDetailPtum = load(lazy(() => import('../riwayat-pengajuan/unit/riwayat-pengajuan-detail-ptum')));
const ValidasiPengajuanFinance = load(lazy(() => import('../approvers-finance/validasi-pengajuan/validasi-pengajuan')));
const DetailPengajuanFinance = load(lazy(() => import('../approvers-finance/validasi-pengajuan/detail-pengajuan')));
const RiwayatPengajuanFinance = load(lazy(() => import('../riwayat-pengajuan/finance/riwayat-pengajuan-list')));
const RiwayatPengajuanDetailFinanceBkkb = load(lazy(() => import('../riwayat-pengajuan/finance/riwayat-pengajuan-detail-bkkb')));
const RiwayatPengajuanDetailFinanceBtkb = load(lazy(() => import('../riwayat-pengajuan/finance/riwayat-pengajuan-detail-btkb')));
const RiwayatPengajuanDetailFinanceBj = load(lazy(() => import('../riwayat-pengajuan/finance/riwayat-pengajuan-detail-bj')));

const Index = () => {
    return (<>
        <div className="app-container app-theme-white body-tabs-shadow fixed-header fixed-sidebar">
            <Header />
            <div className="app-main">
                <Sidebar />
                <div className="app-main__outer">
                    <div className="app-main__inner">
                        <Switch>
                            <Route
                                path={Routes.DashboardExecutiveDirector.path}
                                render={props => <Dashboard {...props} />}
                            />
                            <Route
                                path={Routes.ValidasiPengajuanExecutiveDirector.path}
                                render={props => <ValidasiPengajuan {...props} />}
                            />
                            <Route
                                path={Routes.DetailPengajuanExecutiveDirector.path}
                                render={props => <DetailPengajuan {...props} />}
                            />
                            <Route
                                path={Routes.RiwayatPengajuanExecutiveDirector.path}
                                render={props => <RiwayatPengajuan {...props} />}
                            />
                            <Route
                                path={Routes.RiwayatPengajuanDetailPpbjExecutiveDirector.path}
                                render={props => <RiwayatPengajuanDetailPpbj {...props} />}
                            />
                            <Route
                                path={Routes.RiwayatPengajuanDetailPtumExecutiveDirector.path}
                                render={props => <RiwayatPengajuanDetailPtum {...props} />}
                            />
                            <Route
                                path={Routes.ValidasiPengajuanKeuanganExecutiveDirector.path}
                                render={props => <ValidasiPengajuanFinance {...props} />}
                            />
                            <Route
                                path={Routes.DetailPengajuanKeuanganExecutiveDirector.path}
                                render={props => <DetailPengajuanFinance {...props} />}
                            />
                            <Route
                                path={Routes.RiwayatPengajuanKeuanganExecutiveDirector.path}
                                render={props => <RiwayatPengajuanFinance {...props} />}
                            />
                            <Route
                                path={Routes.RiwayatPengajuanDetailKeuanganExecutiveDirector.path.replace(':type', 'bkkb')}
                                render={props => <RiwayatPengajuanDetailFinanceBkkb {...props} />}
                            />
                            <Route
                                path={Routes.RiwayatPengajuanDetailKeuanganExecutiveDirector.path.replace(':type', 'btkb')}
                                render={props => <RiwayatPengajuanDetailFinanceBtkb {...props} />}
                            />
                            <Route
                                path={Routes.RiwayatPengajuanDetailKeuanganExecutiveDirector.path.replace(':type', 'bj')}
                                render={props => <RiwayatPengajuanDetailFinanceBj {...props} />}
                            />
                            <Route render={() => <DirectorNotFound />} />
                        </Switch>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>

        <ToastContainer />
        <Assets />
    </>);
}

export default Index;